/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VehicleOwner } from './vehicleOwner';
import { Driver } from './driver';
import { PurchasePrice } from './purchasePrice';
import { Truck } from './truck';
import { ConstructionKind } from './constructionKind';
import { Trailer } from './trailer';
import { LicensePlateData } from './licensePlateData';
import { VehicleUsage } from './vehicleUsage';
import { Car } from './car';
import { NewPrice } from './newPrice';
import { SpecialEquipment } from './specialEquipment';
import { OwnershipRelationship } from './ownershipRelationship';
import { Bike } from './bike';

/**
 * @type InsuredObject
 * @export
 */
export type InsuredObject = Bike | Car | Trailer | Truck;
